"use client";

import { ErrorFallback } from "@/shared";
import { PAGE_ERROR_MAP } from "@/shared/constants";

/**
 * 404 Not Found 페이지
 *
 * - 존재하지 않는 경로 접근 시 표시
 * - Server Component로 동작
 */
export default function NotFound() {
  const { label, message } = PAGE_ERROR_MAP["PE01"];

  return <ErrorFallback title={label} message={message} showHomeButton showBackground />;
}
